import offerSchemaType from './helpers/offerSchemaType'
import offerSchemaName from './helpers/offerSchemaName'
import offerSchemaLink from './helpers/offerSchemaLink'
import offerSchemaImage from './helpers/offerSchemaImage'
import offerSchemaBrand from './helpers/offerSchemaBrand'

export default function search (buy, category, offers) {
    return {
        "@context": "http://schema.org",
        "@type": "SearchResultsPage",
        "mainEntity": [{
            "@type": "ItemList",
            "name": category,
            "itemListOrder": "http://schema.org/ItemListOrderDescending",
            "itemListElement": offers.map((offer, idx) => {
                const name = offerSchemaName(buy, offer)
                const type = offerSchemaType(offer.type)
                const includeRating = type !== 'Service'
                return {
                    "@type": "ListItem",
                    "position": idx + 1,
                    "item": {
                        "name": name,
                        "@type": type,
                        "url": offerSchemaLink(buy, offer),
                        "image": offerSchemaImage(buy, offer),
                        "brand": offerSchemaBrand(buy, offer),
                        "description": name,
                        ...(includeRating
                            ? { "aggregateRating": {
                                "ratingValue": 5,
                                "ratingCount": 1,
                              }}
                            : {}),
                    },
                }
            })
        }]
    }
}